module.exports = __webpack_public_path__ + "img/product-help.1d284a32.svg";